import { and, eq, type InitialQueryBuilder } from "@tanstack/db";

import type { WsBroadcastRecipient } from "@storyboard/web-client";
import { store } from "@/store/store";
import type { BroadcastRecipient } from "@/store/types";

export const bulkUpsertBroadcastRecipients = async (broadcastRecipientRecords: WsBroadcastRecipient[]) => {
  if (broadcastRecipientRecords.length === 0) return;
  const data = broadcastRecipientRecords.map(
    (r): BroadcastRecipient => ({
      id: r.id,
      broadcastId: r.broadcastId,
      workspaceId: r.workspaceId,
      feedId: r.feedId ?? null,
      workspaceMembershipId: r.workspaceMembershipId ?? null,
      createdAt: r.createdAt ?? null,
    }),
  );
  store.upsert("broadcastRecipient", data);
};

export const broadcastRecipientsQuery = (broadcastId: string) => (q: InitialQueryBuilder) =>
  q
    .from({ recipient: store.collection("broadcastRecipient") })
    .where(({ recipient }) => eq(recipient.broadcastId, broadcastId));

export type BroadcastRecipientListRow = {
  id: string;
  broadcastId: string;
  feedId: string | null;
  title: string | null;
};

export const broadcastRecipientsListQuery = (workspaceId: string, broadcastId?: string) => (q: InitialQueryBuilder) =>
  q
    .from({ recipient: store.collection("broadcastRecipient") })
    .innerJoin({ feed: store.collection("feed") }, ({ recipient, feed }) => eq(recipient.feedId, feed.id))
    .where(({ recipient }) =>
      broadcastId
        ? and(eq(recipient.workspaceId, workspaceId), eq(recipient.broadcastId, broadcastId))
        : eq(recipient.workspaceId, workspaceId),
    )
    .select(({ recipient, feed }) => ({
      id: recipient.id,
      broadcastId: recipient.broadcastId,
      feedId: recipient.feedId,
      title: feed.title,
    }));
